import { Circle, Icon, SquareProps } from "@chakra-ui/react";
import { HiCheck } from "react-icons/hi";

interface RadioCircleProps extends SquareProps {
  isCompleted: boolean;
  isActive: boolean;
}

export function StepCircle(props: RadioCircleProps) {
  const { isCompleted, isActive } = props;
  return (
    <Circle
      size={"6"}
      bg={isCompleted ? "brand.500" : "inherit"}
      borderWidth={isCompleted ? "0" : "2px"}
      borderColor={isActive ? "brand.500" : "gray.400"}
      {...props}
    >
      {isCompleted ? (
        <Icon as={HiCheck} color={"white"} boxSize={"4"} />
      ) : (
        <Circle bg={isActive ? "brand.500" : "border"} size={"2.5"} />
      )}
    </Circle>
  );
}
